import { css } from "@emotion/react";
import { media } from "styles/breakpoints";
import { theme } from "styles/theme";

export const InputCustomStyle = {
  self: css`
    &.ant-input,
    .ant-input {
      width: 100%;
      height: 44px;
      border: 1px solid ${theme.borders.secondary};
      padding: 5px 10px;
      font-size: 14px;
      background: transparent;
      border-radius: 8px;
      color: ${theme.colors.lightText};
      outline: none;
      box-shadow: none;
      font-weight: 500;
      ${media["2sm"]} {
        input {
          box-shadow: none;
        }
      }

      &:-webkit-autofill {
        -webkit-background-clip: text;
        -webkit-text-fill-color: ${theme.colors.lightText};
      }

      &:focus,
      &:hover {
        border-color: ${theme.borders.tertiary};
        &:-webkit-autofill {
          -webkit-background-clip: text;
          -webkit-text-fill-color: ${theme.colors.lightText};
        }
      }
      &-disabled {
        opacity: 0.8;
        background: #363636;

        ${media.md} {
          opacity: 0.5;
        }
      }
      &::placeholder {
        opacity: 0.6;
        color: ${theme.colors.lightText};
      }

      &-status-error {
        border-color: var(--error-color) !important;
        &::placeholder {
          color: var(--error-color);
        }
      }
    }
    & .ant-form-item-explain-error {
      color: var(--error-color) !important;
    }

    input[type="number"]::-webkit-inner-spin-button,
    input[type="number"]::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  `,
};
